import { Const } from '../const.mod';
/**
 * getters extension for store module
 */
export var getters = (_a = {},
    /**
     * return current heartbeats for all providers
     */
    _a[Const.GET_HEARTBEATS] = function (state) {
        return state.heartbeats;
    },
    /**
     * return all providers
     */
    _a[Const.GET_PROVIDERS] = function (state) {
        return state.providers;
    },
    _a);
var _a;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/store/getters.ts
// module id = null
// module chunks = 